export interface MapZoomInterval {
  start: number;
  end: number;
}

export const MapZoomLevels = {
  MARKET: { start: 1, end: 5 },
  SUBMARKET: { start: 6, end: 7 },
  ZIP: { start: 8, end: 9 },
  PROPERTY: { start: 10, end: 22 },

  isInLevel: (zoom: number, level: MapZoomInterval): boolean => zoom >= level.start && zoom <= level.end
};



// WEBPACK FOOTER //
// ./src/app/shared/configs/MapZoomLevels.ts